
Chart.defaults.global.legend.display = false;

if ($('#calcola-mutuo').length) {
    var ctx = $("#mutuoChart");
    var tf  = calcoloRataMutuo(1, null);
    var tv  = calcoloRataMutuo(1, null,'TV');

    /**
     * Inizializzazione grafico tasso fisso
     * @type Chart
     */
    var graficoTF = new Chart(ctx, {
        type: "doughnut",
        data: {
            labels: [
                $("#mutuoLabelTF").html(),
                $("#anticipoLabelTF").html()
            ],
            datasets: [{
                data: [
                    tf.nMutuoPerc,
                    tf.nMutuoPercAnticipo
                ],
                backgroundColor: ["#001741", "#1061a6"],
                label: "My dataset" // for legend
            }]
        },
        options: {
            cutoutPercentage: 70
        },
        legend: {
            display: false
        }
    });

    /**
     * Inizializzazione grafico tasso variabile
     * @type Chart
     */
    var graficoTV = new Chart($("#mutuoChartTV"), {
        type: "doughnut",
        data: {
            labels: [
                $("#mutuoLabelTV").html(),
                $("#anticipoLabelTV").html()
            ],
            datasets: [{
                data: [
                    tv.nMutuoPerc,
                    tv.nMutuoPercAnticipo
                ],
                backgroundColor: ["#001741", "#1061a6"],
                label: "My dataset" // for legend
            }]
        },
        options: {
            cutoutPercentage: 70
        },
        legend: {
            display: false
        }
    });


    $("#immobilePrezzo").keyup(function() {
        calcoloRataMutuo(null, graficoTF);
        calcoloRataMutuo(null, graficoTV, 'TV');
    });
    $(".calcoloMutuoValue").keyup(function() {
        calcoloRataMutuo(null, graficoTF);
        calcoloRataMutuo(null, graficoTV, 'TV');
    });
    $(".calcoloMutuoValue").change(function() {
        calcoloRataMutuo(null, graficoTF);
        calcoloRataMutuo(null, graficoTV, 'TV');
    });

}

$(".inviaRichiestaMutuo #mutuoDurata").change(function() {
    graficoTF = new Chart(ctx, {
        type: "doughnut",
        data: {
            labels: [
                $("#mutuoLabelTF").html(),
                $("#anticipoLabelTF").html()
            ],
            datasets: [{
                data: [
                    0,
                    100
                ],
                backgroundColor: ["#001741", "#1061a6"],
                label: "My dataset" // for legend
            }]
        },
        options: {
            cutoutPercentage: 70
        },
        legend: {
            display: false
        }
    });

    graficoTV = new Chart($("#mutuoChartTV"), {
        type: "doughnut",
        data: {
            labels: [
                $("#mutuoLabelTV").html(),
                $("#anticipoLabelTV").html()
            ],
            datasets: [{
                data: [
                    0,
                    100
                ],
                backgroundColor: ["#001741", "#1061a6"],
                label: "My dataset" // for legend
            }]
        },
        options: {
            cutoutPercentage: 70
        },
        legend: {
            display: false
        }
    });
    calcoloRataMutuo(null, graficoTF);
    calcoloRataMutuo(null, graficoTV, 'TV');
});

function calcoloRataMutuo(init, chart, tipoTasso = 'TF') {
    var nValore = $("#immobilePrezzo").val().replace(/\./g, "");
    var nValore = parseInt(nValore);
    var nCapitale = $("#mutuoImporto").val().replace(/\./g, "");
    var nCapitale = parseInt(nCapitale);
    var nCadenza = 12;
    if ($('#mutuoDurata option:selected').length == 0) {
        $('#mutuoDurata option:eq(4)').prop('selected', true);
    }
    var nAnniMutuo = $("#mutuoDurata").val();
    if (tipoTasso == 'TF') {
        var nTasso = $("#mutuoDurata option:selected").attr("data-rel");
    } else {
        var nTasso = $("#mutuoDurata option:selected").attr("data-tv");
    }
    var nLimitMutuo = nValore / 100 * 100;
    if (nCapitale > nLimitMutuo) {
        nCapitale = nLimitMutuo;
    }

    nTassoTF    = $("#mutuoDurata option:selected").attr("data-rel");
    $("#tassoChange").html("Fisso: "+nTassoTF+"% - Variabile: "+nTasso.replace(".",",")+"%");

    if (parseInt(nCapitale) <= parseInt(nValore)) {
        $("#mutuoRata").html(0);
        var nMesiMutuo = nAnniMutuo * nCadenza;
        var nTassoMese = nTasso / (100 * nCadenza);
        var nTarroCalcolo = nTassoMese + 1;
        var nMesiCalcolo = nMesiMutuo - 1;
        var nSomma = 0;
        for (i = 0; i < nMesiCalcolo; i++) {
            nPow = Math.pow(nTarroCalcolo, i);
            nSomma += nPow;
        }
        var nPot = Math.pow(nTarroCalcolo, nMesiMutuo);
        var nRata = nCapitale * nPot / nSomma;
        var nTassoot = nRata * nMesiMutuo;
        var nInteressi = nTassoot - nCapitale;
        var nMutuoPerc = parseInt(nCapitale / nValore * 100);
        var nMutuoPercAnticipo = 100 - nMutuoPerc;
        if (nRata < 1) {
            nRata = 0;
        }
        if (nRata > 1) {
            nRata = number_format(nRata, 0, ",", ".");
        }
        $("#mutuoRata" + tipoTasso).html(nRata);
        $("#mutuoPercAnticipo" + tipoTasso).html(nMutuoPercAnticipo);
        $("#mutuoPerc" + tipoTasso).html(parseInt(nMutuoPerc));
    }
    $("#mutuoImporto").val(number_format(nCapitale, 0, ",", "."));
    $("#immobilePrezzo").val(number_format(nValore, 0, ",", "."));
    // Passaggio valori chart mutuo
    if (init === null) {
        chart.data.datasets[0].data[0] = nMutuoPerc;
        chart.data.datasets[0].data[1] = nMutuoPercAnticipo;
        chart.update();
    }
    aggiornaHrefMutuo();

    return {
        nMutuoPerc: nMutuoPerc,
        nMutuoPercAnticipo: nMutuoPercAnticipo
    }
}
if ($("#importoimmobile").length > 0) {
    value = $("#importoimmobile").val();
    value = value ? number_format($("#importoimmobile").val(), 0, ",", ".") : '';
    $("#importoimmobile").val(value);
}
if ($("#importomutuo").length > 0) {
    value = $("#importomutuo").val();
    value = value ? number_format($("#importomutuo").val(), 0, ",", ".") : '';
    $("#importomutuo").val(value);
}
function aggiornaHrefMutuo() {
    if ($('input#mutuoImporto').length) {
        immobileImporto = parseInt($("input#immobilePrezzo").val().replace(".", ""));
        mutuoImporto = parseInt($("input#mutuoImporto").val().replace(".", ""));
        mutuoDurata = $("#mutuoDurata").val();
        hrefRichiestaMutuo = $("#richiesta-mutuo").attr("href").split("?")[0];
        $('#richiesta-mutuo').attr("href", hrefRichiestaMutuo + "?importo_immobile=" + immobileImporto + "&importo_mutuo=" + mutuoImporto + "&durata_mutuo=" + mutuoDurata + "&tipo_tasso=TF");
        $('#richiesta-mutuoTV').attr("href", hrefRichiestaMutuo + "?importo_immobile=" + immobileImporto + "&importo_mutuo=" + mutuoImporto + "&durata_mutuo=" + mutuoDurata + "&tipo_tasso=TV");
    }
}
